export default {
  component: () => import('./page.vue'),
  path: '/new',
  name: 'new',
  meta: {
    auth: true,
  },
};
